export default __webpack_public_path__ + "static/media/none_avatar.0eed442f.svg";